import React from 'react';
import * as Config from '../config/Config';
import * as Common from '../helpers/Common';
const win=window;
const $=win.$;

export default class TestGraph extends React.Component {
  	constructor(props) {
        super(props);
        this.state = { apicall:'' }
  	}  

  	componentDidMount(){
        let self = this;
        let cgdata = self.props.scoredet; 
        let greater=cgdata.greaterscorecount;
        let currentp=cgdata.currentscorecount;
        let lesser=cgdata.lesserscorecount;
        let score=cgdata.actual_score;
        setTimeout(()=>{
            let chartData = [{
                year: "% people with the score",
                greater: greater,
                current: currentp ,
                lesser: lesser ,
            }];
         
            //SERIALL CHART
            let chart = new win.AmCharts.AmSerialChart(); 
            chart.dataProvider = chartData;
            chart.categoryField = "year";
            chart.plotAreaBorderAlpha = 0;
            chart.rotate = true;
            chart.depth3D = 30;
            chart.angle = 20;

            // AXES
            // Category
            let categoryAxis = chart.categoryAxis;
            categoryAxis.gridAlpha = 0;
            categoryAxis.axisAlpha = 0;
            categoryAxis.gridPosition = "start";
            // value
            let valueAxis = new win.AmCharts.ValueAxis();
            valueAxis.stackType = "regular";
            valueAxis.gridAlpha = 0;
            valueAxis.axisAlpha = 0;
            valueAxis.labelsEnabled = false;
            chart.addValueAxis(valueAxis);
            // GRAPHS
            // firstgraph
            let graph1 = new win.AmCharts.AmGraph();
            graph1.title = "Score < "+score;
            graph1.labelText = "[[value]]%";
            graph1.balloonText = "[[value]]%";
            graph1.valueField = "lesser";
            graph1.type = "column";
            graph1.lineAlpha = 0;

            graph1.fillAlphas = 1;
            graph1.lineColor = "#ff3c8f";
            chart.addGraph(graph1);
            // second graph
            let graph2 = new win.AmCharts.AmGraph();
            graph2.title = "Score = "+score;
            graph2.labelText = "[[value]]%";
            graph2.balloonText = "[[value]]%";
            graph2.valueField = "current";
            graph2.type = "column";
            graph2.lineAlpha = 0;

            graph2.fillAlphas = 1;
            graph2.lineColor = "#10ea10";
            chart.addGraph(graph2);

            // thirdt graph
            let graph3 = new win.AmCharts.AmGraph();
            graph3.title = "Score > "+score;
            graph3.labelText = "[[value]]%";
            graph3.balloonText = "[[value]]%";
            graph3.valueField = "greater";
            graph3.type = "column";
            graph3.lineAlpha = 0;

            graph3.fillAlphas = 1;
            graph3.lineColor = "#0090ff";
            chart.addGraph(graph3);

            // LEGEND
            let legend = new win.AmCharts.AmLegend();
            legend.position = "bottom";
            legend.borderAlpha = 0;
            legend.horizontalGap = 0;
            legend.switchType = "v";
            legend.switchable = false;
            legend.textClickEnabled = false;
            chart.addLegend(legend);
            // WRITE
            chart.write("chartdiv");
        },300);
  	}
    render() {
        let self =this;
        let cgdata = self.props;
        let paddingleft = parseFloat(410*(cgdata.lesser/100)+25);
        let width= parseFloat(410*(cgdata.currentp/100));
         
    	return (      		
        <div className="lr-gray-box">
            <div className="resultchart" >
             <div>Your Perfomance in this Quiz</div>
             <div style={{marginLeft:'165px', paddingLeft:paddingleft+'px', width:width+'px', textAlign:'center',marginRight:'0',paddingRight:'0',marginTop:'20px',marginBottom:'-25px'}}><img src={process.env.PUBLIC_URL+"images/yourscore.jpg"} border="0" alt="" /></div>
             <div ref="chartdiv" id="chartdiv" style={{width:'100%',height:'180px'}}></div>
             <br />
            </div>
            </div>
    	);
  	}
}



// WEBPACK FOOTER //
// ./src/components/TestGraph.js